module.exports = __webpack_public_path__ + "img/slideImage_butsuzo.43ebcc4d.jpg";